import { createCrudPage } from './factories/crud-page.js';

export default createCrudPage({
  title: 'Expos (Events)',
  basePath: '/expo',
  columns: [
    { key: 'type_name', label: 'Type', sortable: true },
    { key: 'title', label: 'Title', sortable: true },
    { key: 'continent_name', label: 'Continent', sortable: true },
    { key: 'country_name', label: 'Country', sortable: true },
    { key: 'city', label: 'City', sortable: true },
    { key: 'start', label: 'Start', sortable: true },
    { key: 'finish', label: 'Finish', sortable: true },
  ],
  fields: [
    { key: 'expo_main_id', label: 'Parent Expo', type: 'async-select',
      optionsUrl: '/expo-main/options',
      placeholder: 'Select parent expo', required: true },
    { key: 'title', label: 'Title', type: 'text', required: true },
    { key: 'type', label: 'Event type', type: 'async-select',
      optionsUrl: '/expo-types/options',
      placeholder: 'Select type' },
    { key: 'continent', label: 'Continent', type: 'async-select',
      optionsUrl: '/expo-continents/options',
      placeholder: 'Select continent' },
    { key: 'country', label: 'Country', type: 'text' },
    { key: 'city', label: 'City', type: 'text' },
    { key: 'start', label: 'Start', type: 'datetime' },
    { key: 'finish', label: 'Finish', type: 'datetime' },
    { key: 'website', label: 'Website', type: 'text' },
    { key: 'description', label: 'Description', type: 'rich-text' },
    { key: 'booth', label: 'Booth', type: 'text' },
    { key: 'logo', label: 'Logo', type: 'file', accept: 'image/*', photo: true },
  ],
  filters: [
    { key: 'expoMain', label: 'Parent Expo', type: 'select',
      optionsUrl: '/expo-main/options' },
  ],
  defaultSort: { field: 'start', dir: 'desc' },
});
